// extracted by mini-css-extract-plugin
export default {"dashboard-header":"style_dashboard-header__-Ajq-","dashboard-banner":"style_dashboard-banner__DGm+R"};